export function getMentionedIdsFromHtml(commentHtml: string): number[] {
  const matches = commentHtml.match(/data-id="(\d+)"/g) || [];

  // eslint-disable-next-line unicorn/prefer-string-replace-all
  return matches.map((match) => Number(match.replace(/\D/g, "")));
}
